export const CHANGE_LOCALE = "CHANGE_LOCALE";
export const SWITCH_THEME = "SWITCH_THEME";
export const TOGGLE_COLLAPSED_NAV = "TOGGLE_COLLAPSED_NAV";
